const crypto = require("crypto");
import userManager from "@/apis/users";
import axios from "axios";

const AvatarServices = (function () {
  return {
    gravatarCache: {},
    avatarCache: {},
    fetchingGravatar: {},

    clearCaches: function () {
      AvatarServices.gravatarCache = {};
      AvatarServices.avatarCache = {};
      AvatarServices.fetchingGravatar = {};
    },

    removeAvatarFromCache: function (id) {
      if (id in AvatarServices.avatarCache) {
        delete AvatarServices.avatarCache[id];
      }
    },

    fetchAvatar: function (id, customer) {
      return new Promise(function (resolve, reject) {
        let key = id;
        if (customer) key = "c_" + id;

        if (id) {
          if (key in AvatarServices.avatarCache) {
            resolve(AvatarServices.avatarCache[key]);
          } else {
            if (!AvatarServices.fetchingGravatar[key]) {
              AvatarServices.fetchingGravatar[key] = [];
              userManager
                .fetchAvatar(id, customer)
                .then((result) => {
                  if (result) {
                    AvatarServices.avatarCache[key] = result;
                    let items = AvatarServices.fetchingGravatar[key];
                    for (let n = 0; n < items.length; n++) {
                      items[n].resolve(result);
                    }
                    delete AvatarServices.fetchingGravatar[key];
                    resolve(result);
                  } else {
                    let items = AvatarServices.fetchingGravatar[key];
                    for (let n = 0; n < items.length; n++) {
                      items[n].reject();
                    }
                    delete AvatarServices.fetchingGravatar[key];
                    reject();
                  }
                })
                .catch((err) => {
                  console.log(err);
                  reject(err);
                });
              // We are not fetching the same gravatar, proceed with the request
            } else {
              // Push the promise in the queue , it will be triggere once the gravatar is fetched
              AvatarServices.fetchingGravatar[key].push({
                resolve: resolve,
                reject: reject,
              });
            }
          }
        } else {
          reject("Invalid id");
        }
      });
    },

    fetchGravatar: function (email) {
      return new Promise(function (resolve /*, reject*/) {
        if (email in AvatarServices.gravatarCache) {
          resolve(AvatarServices.gravatarCache[email]);
        } else {
          var hash = crypto
            .createHash("md5")
            .update(email.toLowerCase())
            .digest("hex");
          let url = "https://www.gravatar.com/avatar/" + hash + "?s=256&d=404";
          var requestSettings = {
            url: url,
            method: "GET",
            encoding: null,
          };
          axios(requestSettings)
            .then((response) => {
              let avatar = response.toString("base64");
              AvatarServices.gravatarCache[email] = avatar;
              resolve(avatar);
            })
            .catch(() => {
              AvatarServices.gravatarCache[email] = "";
              resolve();
            });
        }
      });
    },
  };
})();

export default AvatarServices;
